// Stripe hosted checkout (payment link).
// Clicking any Buy button redirects here to Stripe's secure hosted checkout,
// which accepts cards, Apple Pay, Klarna, Link, Cash App Pay, Amazon Pay & more.
export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/28E00jdp4aIBgW1csW8g000";

// Safe GA4 event helper — no-op if gtag isn't loaded yet.
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export function startCheckout() {
  // Fire GA4 checkout-start / purchase-intent conversion before redirecting to Stripe.
  trackEvent("begin_checkout", {
    currency: "USD",
    value: 27.0,
    items: [
      {
        item_id: "FACELESS-BUNDLE-11",
        item_name: "The Faceless Marketing Bundle",
        price: 27.0,
        quantity: 1,
      },
    ],
  });
  window.location.href = STRIPE_PAYMENT_LINK;
}
